"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var account_1 = __importDefault(require("./account"));

var get_1 = __importDefault(require("lodash/get"));

var xyaInstance = {
  doesUserExistUri: process.env.REACT_APP_USER_EXISTS || '',
  error: '',
  xya: null
};
var xyaInstancePromise = null;

exports.currentXyaInstance = function () {
  return xyaInstance;
};

exports.Context = react_1.createContext(xyaInstance);
exports.Consumer = exports.Context.Consumer;
exports.Provider = exports.Context.Provider;

exports.useXYUserExistsServiceUri = function (doesUserExistUri) {
  xyaInstance.doesUserExistUri = doesUserExistUri;
};

exports.useXyAccountContext = function () {
  var xyaContext = react_1.useContext(exports.Context);
  if (xyaContext.xya) return xyaContext.xya;
  if (xyaContext.error) throw xyaContext.error;
  if (xyaInstancePromise) throw xyaInstancePromise;
  xyaInstancePromise = initAccount().then(function (xya) {
    xyaContext.xya = xya;
    return xyaContext;
  }).catch(function (error) {
    xyaContext.error = error.message;
    return xyaContext;
  });
  throw xyaInstancePromise;
};

exports.useXyAccountAccessToken = function () {
  var xya = exports.currentXyaInstance().xya;
  if (!xya) return null;
  var currentUser = xya.currentUser();
  if (!currentUser) return null;
  return get_1.default(currentUser.toJSON(), 'stsTokenManager.accessToken');
};

function isXYAccount(xya) {
  return !!xya;
}

exports.isXYAccount = isXYAccount;

function doesUserExist(email) {
  return __awaiter(this, void 0, void 0, function () {
    var doesUserExistUri, res, json;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          doesUserExistUri = exports.currentXyaInstance().doesUserExistUri;

          if (!doesUserExistUri) {
            throw new Error('User exists service uri was not supplied');
          }

          return [4
          /*yield*/
          , fetch(doesUserExistUri + "?email=" + email)];

        case 1:
          res = _a.sent();
          return [4
          /*yield*/
          , res.json()];

        case 2:
          json = _a.sent();
          return [2
          /*return*/
          , json.result];
      }
    });
  });
}

exports.doesUserExist = doesUserExist;

var initAccount = function initAccount() {
  return new Promise(function (res) {
    var account = new account_1.default(function () {
      res(account);
    });
  });
};